<nav class="nav nav-secondary account-navbar">
  <!--Account-->
  <a
    class="nav-item"
    [routerLink]="['/hawksbucks']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.hawksbucks.screenreader' | translate: { fgbdefault: 'Move to hawksbucks page' } }}"
  >
    <label>{{ 'account.nav.hawksbucks' | translate }}</label>
  </a>

  <a
    class="nav-item"
    [routerLink]="['/transfer']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.transfer.screenreader' | translate: { fgbdefault: 'Move to transfer page' } }}"
  >
    <label>{{ 'account.nav.transfer' | translate }}</label>
  </a>
</nav>
